import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store/index'
import Permissions from '@/model/Permissions'

Vue.use(VueRouter)


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/home/MainDashboard.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: () => import('@/views/calendar/CalendarView.vue'),
      meta: {
        pageTitle: 'Calendar',
        permissions: [Permissions.CALENDAR_READ],
        breadcrumb: [
          {
            text: 'Calendar',
            active: true,
          },
        ],
      },
    },
    {
      path: '/hierarchy',
      name: 'hierarchy',
      component: () => import('@/views/hierarchy/HierarchyView2.vue'),
      meta: {
        pageTitle: 'Hierarchy',
        permissions: [Permissions.HIERARCHY_READ],
        breadcrumb: [
          {
            text: 'Hierarchy',
            active: true,
          },
        ],
      },
    },
    {
      path: '/clients',
      name: 'clients',
      component: () => import('@/views/clients/ClientsView.vue'),
      meta: {
        pageTitle: 'Clients',
        pageKey: 'all',
        permissions: [Permissions.CLIENT_READ_ALL],
        breadcrumb: [
          {
            text: 'Clients',
            active: true,
          },
        ],
      },
    },
    {
      path: '/client/:clientId',
      name: 'client',
      component: () => import('@/views/clients/ClientView.vue'),
      meta: {
        pageTitle: 'Clients',
        pageKey: 'all',
        layout: 'full',
        permissions: [Permissions.CLIENT_READ_ALL],
        breadcrumb: [
          {
            text: 'Clients',
            active: true,
          },
        ],
      },
    },
    {
      path: '/clients/sales',
      name: 'sales',
      component: () => import('@/views/clients/ClientsView.vue'),
      meta: {
        pageTitle: 'Sales',
        pageName: 'Sales',
        pageKey: 'sales',
        permissions: [Permissions.CLIENT_READ],
        departments: ['SALES'],
        breadcrumb: [
          {
            text: 'Sales',
            active: true,
          },
        ],
      },
    },{
      path: '/clients/retention',
      name: 'retention',
      component: () => import('@/views/clients/ClientsView.vue'),
      meta: {
        pageTitle: 'Retentions',
        pageName: 'Retentions',
        pageKey: 'retentions',
        permissions: [Permissions.CLIENT_RETENTION, Permissions.CLIENT_READ_ALL],
        departments: ['RETENTION'],
        breadcrumb: [
          {
            text: 'Retentions',
            active: true,
          },
        ],
      },
    },
    {
      path: '/clients/chat',
      name: 'clientsChat',
      component: () => import('@/views/chat/Chat.vue'),
      meta: {
        contentRenderer: 'sidebar-left',
        contentClass: 'chat-application',
        pageTitle: 'Chat',
        pageName: 'Chat',
        pageKey: 'clientsChat',
        departments: ['RETENTION'],
        breadcrumb: [
          {
            text: 'chat',
            active: true,
          },
        ],
      },
    },
    {
      path: '/affiliates',
      name: 'affiliates',
      component: () => import('@/views/affiliates/AffiliatesView.vue'),
      meta: {
        pageTitle: 'Affiliates',
        permissions: [Permissions.AFFILIATE_READ_ALL],
        breadcrumb: [
          {
            text: 'Affiliates',
            active: true,
          },
        ],
      },
    },
    {
      path: '/monetaries',
      name: 'monetaries',
      component: () => import('@/views/monetaries/MonetaryView.vue'),
      meta: {
        pageTitle: 'Monetary transactions',
        permissions: [Permissions.MONETARY_READ_ALL],
        breadcrumb: [
          {
            text: 'Monetary transactions',
            active: true,
          },
        ],
      },
    },
    {
      // Read-only, URL-driven transactions list — opened in a NEW TAB from
      // dashboard KPI cards. Shows the EXACT filtered data behind the KPI
      // (single table, exact filters), plus totals + an editable filter bar.
      path: '/monetaries/view',
      name: 'filteredMonetaries',
      component: () => import('@/views/monetaries/FilteredMonetariesView.vue'),
      meta: {
        pageTitle: 'Monetary transactions',
        permissions: [Permissions.MONETARY_READ_ALL],
        breadcrumb: [
          {
            text: 'Monetary transactions',
            active: true,
          },
        ],
      },
    },
    {
      path: '/brands',
      name: 'brands',
      component: () => import('@/views/brand/BrandView.vue'),
      meta: {
        pageTitle: 'Brands',
        permissions: [Permissions.MARKETING_READ_ALL],
        breadcrumb: [
          {
            text: 'Brands',
            active: true,
          },
        ],
      },
    }, {
      path: '/leads',
      name: 'leads',
      component: () => import('@/views/lead/LeadView.vue'),
      meta: {
        pageTitle: 'Leads',
        permissions: [Permissions.MARKETING_READ_ALL],
        breadcrumb: [
          {
            text: 'Leads',
            active: true,
          },
        ],
      },
    },
    {
      path: '/campaigns',
      name: 'campaigns',
      component: () => import('@/views/campaign/CampaignView.vue'),
      meta: {
        pageTitle: 'Campaigns',
        permissions: [Permissions.MARKETING_READ_ALL],
        breadcrumb: [
          {
            text: 'Campaigns',
            active: true,
          },
        ],
      },
    },
    {
      path: '/pixels',
      name: 'pixels',
      component: () => import('@/views/campaign/PixelView.vue'),
      meta: {
        pageTitle: 'Facebook Pixels',
        permissions: [Permissions.MARKETING_READ_ALL],
        breadcrumb: [
          {
            text: 'Facebook Pixels',
            active: true,
          },
        ],
      },
    },
    {
      path: '/titans',
      name: 'titans',
      component: () => import('@/views/campaign/TitanView.vue'),
      meta: {
        pageTitle: 'Titan Accounts',
        permissions: [Permissions.MARKETING_READ_ALL],
        breadcrumb: [
          {
            text: 'Titan Accounts',
            active: true,
          },
        ],
      },
    },{
      path: '/campaignDashboard',
      name: 'campaignDashboard',
      component: () => import('@/views/reports/CampaignDashboard.vue'),
      meta: {
        pageTitle: 'Campaign Dashboard',
        permissions: [Permissions.MARKETING_READ_ALL],
        breadcrumb: [
          {
            text: 'Campaign Dashboard',
            active: true,
          },
        ],
      },
    },
    {
      path: '/accounts',
      name: 'accounts',
      component: () => import('@/views/accounts/AccountView.vue'),
      meta: {
        pageTitle: 'CFD Accounts',
        permissions: [Permissions.ACCOUNT_READ_ALL],
        breadcrumb: [
          {
            text: 'CFD Accounts',
            active: true,
          },
        ],
      },
    },
    {

      path: '/monetaries/withdrawalRequests',
      name: 'withdrawalRequests',
      component: () => import('@/views/monetaries/WithdrawView.vue'),
      meta: {
        pageTitle: 'Withdrawal Requests',
        permissions: [Permissions.MONETARY_READ_ALL],
        breadcrumb: [
          {
            text: 'Withdrawal Requests',
            active: true,
          },
        ],
      },
    },
    {
      path: '/configurations/kycs',
      name: 'kycs',
      component: () => import('@/views/kyc/KycView.vue'),
      meta: {
        pageTitle: 'Kycs',
        permissions: [Permissions.KYC_READ_ALL],
        breadcrumb: [
          {
            text: 'Kycs',
            active: true,
          },
        ],
      },
    },  {
      path: '/configurations/clientStatus',
      name: 'clientStatus',
      component: () => import('@/views/clientStatus/ClientStatusView.vue'),
      meta: {
        pageTitle: 'Client status',
        permissions: [Permissions.TRADING_SYSTEM_SYMBOLS_UPDATE],
        breadcrumb: [
          {
            text: 'Client status',
            active: true,
          },
        ],
      },
    },  {
      path: '/configurations/psp',
      name: 'psp',
      component: () => import('@/views/psp/PspView.vue'),
      meta: {
        pageTitle: 'PSPs',
        permissions: [Permissions.PSP_MANAGE],
        breadcrumb: [
          {
            text: 'PSPs',
            active: true,
          },
        ],
      },
    },  {
      path: '/configurations/lead-distribution',
      name: 'leadDistribution',
      component: () => import('@/views/leadDistribution/LeadDistributionView.vue'),
      meta: {
        pageTitle: 'Lead distribution',
        permissions: [Permissions.AFFILIATE_DISTRIBUTION],
        breadcrumb: [
          {
            text: 'Lead distribution',
            active: true,
          },
        ],
      },
    },
    {
      path: '/configurations/trading-system/symbols',
      name: 'symbols',
      component: () => import('@/views/symbol/SymbolView.vue'),
      meta: {
        pageTitle: 'Symbols',
        permissions: [Permissions.TRADING_SYSTEM_SYMBOLS_UPDATE],
        breadcrumb: [
          {
            text: 'Symbols',
            active: true,
          },
        ],
      },
    }, {
      path: '/configurations/trading-system/symbolGroups',
      name: 'symbolGroups',
      component: () => import('@/views/symbolGroup/SymbolGroupView.vue'),
      meta: {
        pageTitle: 'Symbol groups',
        permissions: [Permissions.TRADING_SYSTEM_SYMBOLS_GROUPS_UPDATE],
        breadcrumb: [
          {
            text: 'Symbol groups',
            active: true,
          },
        ],
      },
    }, {
      path: '/trades/closed',
      name: 'closedTrades',
      component: () => import('@/views/trades/ClosedTradesView.vue'),
      meta: {
        pageTitle: 'CFD Orders History',
        permissions: [Permissions.TRADING_READ_ALL],
        breadcrumb: [
          {
            text: 'CFD Orders History',
            active: true,
          },
        ],
      },
    }, {
      path: '/trades/open',
      name: 'trades',
      component: () => import('@/views/trades/OpenTradesView.vue'),
      meta: {
        pageTitle: 'Open CFD Orders',
        permissions: [Permissions.TRADING_READ_ALL],
        breadcrumb: [
          {
            text: 'Open CFD Orders',
            active: true,
          },
        ],
      },
    },
    {
      path: '/configurations/smtps',
      name: 'smtps',
      component: () => import('@/views/smtps/SmtpsView.vue'),
      meta: {
        pageTitle: 'Smtps',
        permissions: [Permissions.SMTP_READ_ALL],
        breadcrumb: [
          {
            text: 'Smtps',
            active: true,
          },
        ],
      },
    },
    {
      path: '/configurations/whitelists',
      name: 'whitelists',
      component: () => import('@/views/whitelists/WhitelistsView.vue'),
      meta: {
        pageTitle: 'Whitelists',
        permissions: [Permissions.WHITELIST_READ_ALL],
        breadcrumb: [
          {
            text: 'Whitelists',
            active: true,
          },
        ],
      },
    },
    {
      path: '/configurations/roles',
      name: 'roles',
      component: () => import('@/views/roles/RolesView.vue'),
      meta: {
        pageTitle: 'Roles',
        permissions: [Permissions.USER_ROLES_READ_ALL],
        breadcrumb: [
          {
            text: 'Users',
            active: true,
          },
        ],
      },
    },
    {
      path: '/configurations/users',
      name: 'users',
      component: () => import('@/views/users/UsersView.vue'),
      meta: {
        pageTitle: 'Users',
        permissions: [Permissions.USER_READ_ALL],
        breadcrumb: [
          {
            text: 'Users',
            active: true,
          },
        ],
      },
    },
    {
      path: '/monitoring',
      name: 'monitoring',
      component: () => import('@/views/monitoring/MonitoringView.vue'),
      meta: {
        pageTitle: 'Monitoring',
        permissions: [Permissions.MONITORING_READ],
        breadcrumb: [
          {
            text: 'monitoring',
            active: true,
          },
        ],
      },
    },
    {
      path: '/configurations/organizations',
      name: 'organizations',
      component: () => import('@/views/organizations/OrganizationsView.vue'),
      meta: {
        pageTitle: 'Organizations',
        permissions: [Permissions.ORG_READ_ALL],
        breadcrumb: [
          {
            text: 'organization',
            active: true,
          },
        ],
      },
    },
    {
      path: '/configurations/businessesUnits',
      name: 'businessUnit',
      component: () => import('@/views/businessUnits/BusinessUnitsView.vue'),
      meta: {
        pageTitle: 'Businesses Units',
        permissions: [Permissions.BU_UPDATE],
        breadcrumb: [
          {
            text: 'business Unit',
            active: true,
          },
        ],
      },
    },
    {
      path: '/tickets',
      name: 'tickets',
      component: () => import('@/views/tickets/TicketsView.vue'),
      meta: {
        pageTitle: 'Tickets',
        permissions: [Permissions.TICKET_READ],
        breadcrumb: [
          {
            text: 'Tickets',
            active: true,
          },
        ],
      },
    },
    {
      path: '/configurations/support',
      name: 'config-support',
      component: () => import('@/views/Support.vue'),
      meta: {
        pageTitle: 'Bug Reporting',
        permissions: [],//Permissions.USER_READ_ALL
        breadcrumb: [
          {
            text: 'report all bugs',
            active: true,
          },
        ],
      },
    },
    {
      path: '/tasks',
      name: 'tasks',
      component: () => import('@/views/tasks/TasksView.vue'),
      meta: {
        pageTitle: 'Tasks',
        breadcrumb: [
          {
            text: 'Tasks',
            active: true,
          },
        ],
        permissions: [Permissions.TASK_READ],
      },
    },
    {
      path: '/mobile/test-dashboard',
      name: 'testDashboard',
      component: () => import('@/views/mobile/TestDashboard.vue'),
      meta: {
        // No pageTitle/breadcrumb: the view renders its own header — the
        // layout's breadcrumb block would duplicate the title on top.
        permissions: [Permissions.MOBILE_DASHBOARD],
      },
    },
    {
      path: '/clients/dashboard',
      name: 'clientDashboard',
      component: () => import('@/views/reports/ClientDashboard.vue'),
      meta: {
        pageTitle: 'Client Dashboard',
        breadcrumb: [
          {
            text: 'Client Dashboard',
            active: true,
          },
        ],
        permissions: [Permissions.MONETARY_REPORT_READ],
      },
    },
    {
      path: '/clients/dashboard/list',
      name: 'clientDashboardList',
      component: () => import('@/views/reports/ClientDashboardList.vue'),
      meta: {
        pageTitle: 'Client Dashboard List',
        breadcrumb: [
          {
            text: 'Client Dashboard List',
            active: true,
          },
        ],
        permissions: [Permissions.MONETARY_REPORT_READ],
      },
    },
    {
      path: '/sales/dashboard',
      name: 'salesDashboard',
      component: () => import('@/views/reports/SalesDashboard.vue'),
      meta: {
        pageTitle: 'Sales Dashboard',
        breadcrumb: [
          {
            text: 'Sales Dashboard',
            active: true,
          },
        ],
        permissions: [Permissions.MONETARY_REPORT_READ],
      },
    },
    {
      path: '/monetary/dashboard',
      name: 'monetaryDashboard',
      component: () => import('@/views/reports/MonetaryDashboard.vue'),
      meta: {
        pageTitle: 'Monetary Dashboard',
        breadcrumb: [
          {
            text: 'Monetary Dashboard',
            active: true,
          },
        ],
        permissions: [Permissions.MONETARY_REPORT_READ],
      },
    }, {
      path: '/finance/dashboard',
      name: 'financeDashboard',
      component: () => import('@/views/reports/FinanceDashboard.vue'),
      meta: {
        pageTitle: 'Finance Dashboard',
        breadcrumb: [
          {
            text: 'Finance Dashboard',
            active: true,
          },
        ],
        permissions: [Permissions.FINANCE_DASHBOARD],
      },
    }, {
      path: '/insights/clients',
      name: 'clientInsights',
      component: () => import('@/views/reports/ClientInsights.vue'),
      meta: {
        pageTitle: 'Client Insights',
        breadcrumb: [
          {
            text: 'Client Insights',
            active: true,
          },
        ],
        permissions: [Permissions.CLIENT_INSIGHTS],
      },
    }, {
      path: '/insights/users',
      name: 'userInsights',
      component: () => import('@/views/reports/UserInsights.vue'),
      meta: {
        pageTitle: 'Agent Insights',
        breadcrumb: [
          {
            text: 'Agent Insights',
            active: true,
          },
        ],
        permissions: [Permissions.USER_INSIGHTS],
      },
    }, {
      path: '/affiliate/dashboard',
      name: 'affiliateDashboard',
      component: () => import('@/views/reports/AffiliateDashboard.vue'),
      meta: {
        pageTitle: 'Affiliate Dashboard',
        breadcrumb: [
          {
            text: 'Affiliate Dashboard',
            active: true,
          },
        ],
        permissions: [Permissions.MONETARY_REPORT_READ],
      },
    },
    {
      path: '/activity/user',
      name: 'userActivity',
      component: () => import('@/views/tracker/UserActivityView.vue'),
      meta: {
        pageTitle: 'User activity',
        breadcrumb: [
          {
            text: 'User activity',
            active: true,
          },
        ],
        permissions: [Permissions.MONETARY_REPORT_READ],
      },
    },
    {
      path: '/activity/client',
      name: 'clientActivity',
      component: () => import('@/views/tracker/ClientActivityView.vue'),
      meta: {
        pageTitle: 'Client activity',
        breadcrumb: [
          {
            text: 'Client activity',
            active: true,
          },
        ],
        permissions: [Permissions.CLIENT_ACTIVITY_READ],
      },
    },
    {
      path: '/configurations/mails',
      name: 'mails',
      component: () => import('@/views/mails/MailTemplatesView.vue'),
      meta: {
        pageTitle: 'Email templates',
        permissions: [Permissions.MAIL_TEMPLATE_READ_ALL],
        breadcrumb: [
          {
            text: 'Email templates',
            active: true,
          },
        ],
      },
    },
    {
      path: '/configurations/about',
      name: 'config-about',
      component: () => import('@/views/config/About.vue'),
      meta: {
        pageTitle: 'About',
        permissions: [],
        breadcrumb: [
          {
            text: 'Email templates',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  try { // Redirect to login page if user is not logged in and trying to access a restricted page
    const publicPages = ['/login']
    const authRequired = !publicPages.includes(to.path)
    if (!authRequired) {
      return next();
    }
    let loggedIn = store.getters['user/loggedIn']
    if (!loggedIn) {
      await store.dispatch('user/checkConnection')
      loggedIn = store.getters['user/loggedIn']
    }
    if (!loggedIn) {
      return next('/login?returnUrl=' + to.fullPath)
    }
    checkPermission(to, next)
  } catch (e) {
    console.log(e)
    return next('/login?returnUrl=' + to.fullPath)
  }
})

function checkPermission(to, next) {
  const permission = to.meta.permissions
  if (!Array.isArray(permission)) {
    return next();
  }
  if (!permission.some(p => store.getters['user/hasPermission'](p))) {
    console.log("User doesn't have permission to access this page", permission)
    return next('/error-404?notAuthorized=true')
  }
  next()
}

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none';
  }
})

export default router
